<template>
  <div class="">
    <Divider title="项目基础信息"></Divider>
    <BasicPlanInfo ref="planFormBasicRef" form-label-width="120px" v-model="planForm">
      <template v-slot:projectname>
        <el-form-item label="计划名称" prop="project_name">
          <DynamicWordsInput v-model="planForm.project_name" :words="V3_DYNAMIC_WORDS">
            <el-input
              reference="input"
              style="width: 320px"
              v-model="planForm.project_name"
              placeholder="最大90个字符, 一个中文等于2个字符"
            ></el-input>
          </DynamicWordsInput>
        </el-form-item>
      </template>
    </BasicPlanInfo>

    <Divider title="营销目标及场景"></Divider>
    <MaketingGoal v-model="planForm" ref="planFormMaketingGoalRef" form-label-width="120px"></MaketingGoal>

    <Divider title="排期和出价设置"></Divider>
    <BudgetBid ref="planFormBidRef" form-label-width="120px" :plan-form="planForm" v-model="budgetForm">
      <template v-slot:daterange>
        <el-form-item label="投放时间">
          <el-date-picker
            v-model="budgetForm.rangeDate"
            :picker-options="{ disabledDate: (date) => date && date.valueOf() < Date.now() - 1000 * 60 * 60 * 24 }"
            type="daterange"
            range-separator="~"
            style="width: 292px"
            value-format="yyyy-MM-dd"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
      </template>

      <template v-slot:materialTags>
        <el-form-item label="投放素材标签（选填）">
          <div class="material-tags">
            <el-select v-model="budgetForm.material_package_id" clearable :disabled="materialPackageDisabled" @change="onMaterialTagChange">
              <el-option v-for="item in materialTagList" :key="item.tagId" :label="item.mediaTagName" :value="item.tagId"> </el-option>
            </el-select>

            <el-button type="text" @click="queryMaterialTags">&ensp;刷新</el-button>
          </div>
        </el-form-item>
      </template>
    </BudgetBid>
  </div>
</template>

<script setup>
import { ref, unref, provide, computed, onMounted } from 'vue'

import { PLATFORM, V3_DYNAMIC_WORDS } from '@/views/create/gdt/model/project-const.js'

import Divider from '@/views/create/bytedance/components/layout/title-divider.vue'
import DynamicWordsInput from '@/components/dynamic-words-input'

import BasicPlanInfo from '@/views/create/gdt/components/plan/basic.vue'
import MaketingGoal from '@/views/create/gdt/v3/components/plan/maketing-goal.vue'
import BudgetBid from '@/views/create/gdt/components/budget/index.vue'

import { useProjectForm, useBudgetForm } from '../../hooks/useProject.js'

const planFormBasicRef = ref(null)
const planFormMaketingGoalRef = ref(null)
const planFormBidRef = ref(null)

const { planForm, budgetForm } = useProjectForm()
const { pageStates, materialPackageDisabled, materialTagList, queryMaterialTags, onMaterialTagChange } = useBudgetForm()

provide('projectInstance', {
  pageStates,
  doPlanFormClearValidate,
  onClearPormotedObject
})

function doPlanFormClearValidate() {}
function onClearPormotedObject() {
  planForm.value = {
    ...planForm.value,
    promotedObject: {}
  }
}

// eslint-disable-next-line
defineExpose({
  setForm: (planform, budgetform) => {
    planForm.value = planform
    budgetForm.value = budgetform
    queryMaterialTags()
  },
  getForm: () => {
    return {
      planForm: unref(planForm),
      budgetForm: unref(budgetForm)
    }
  },
  // validate: () => formRef.value.validate()
  validate: async () => {
    try {
      await planFormBasicRef.value.formValidate()
      await planFormMaketingGoalRef.value.formValidate()
      await planFormBidRef.value.formValidate()
      return Promise.resolve()
    } catch (e) {
      console.log('project form validate error output: ', e)
      return Promise.reject(e)
    }
  }
})
</script>

<style lang="scss" scoped></style>
